//TODO: change this to be "import { PendoUser } from '@social-solutions/component-library'" once typings are fixed for the component library
import { PendoUser } from '@social-solutions/component-library/dist/src/src/components/Generics/Pendo';

export enum AnalyticsEvents {
    TAB_CLICKED = 'SSO Tab Clicked',
    LOGIN_OPTIONS_SAVED = 'SSO Login Options Saved',
}

export interface IAnalyticsMetdata {
    [key: string]: string | number | boolean | string[] | null
}

export type InitOptions = {
    apiKey: string;
    userId: string;
    username: string;
    userType: string;
}

/**
 * Encapsulates the user analytics actions into a single class.
 * Reason: If we change to a different analytics platform such as Gainsight or Google Analytics, the changes are within this file.
 */
export class AnalyticsService {

    private user: PendoUser | null = null;
    private ssoOwnsAnalytics = false;
    constructor(
        private options: InitOptions
    ) {
        if (!!this.options.userId && !!this.options.username && !!this.options.userType) {
            this.user = {
                originalUser: {
                    userId: this.options.userId,
                    username: this.options.username
                },
                userType: this.options.userType
            };
        }
    }


    public ssoShouldInitializeAnalytics() {
        const result = !this.analyticsAreInitialized() && (!!this.options.apiKey && this.user !== null);
        if (result) {
            this.ssoOwnsAnalytics = true;
        }
        return result;

    }
    public analyticsCanInitialize(): boolean {
        return (!!this.options.apiKey && this.user !== null);
    }
    public analyticsAreInitialized(): boolean {
        return (window as unknown as Record<string, unknown>)['pendo'] !== undefined;
    }
    public setSsoInitializedAnalytics(ssoInitializedAnalytics: boolean) {
        this.ssoOwnsAnalytics = ssoInitializedAnalytics;
    }
    public getUser(): PendoUser | null{
        return this.user;
    }

    public track(event: AnalyticsEvents, metadata?: IAnalyticsMetdata): void {
        if (this.analyticsAreInitialized()) {
            if (!pendo.isSendingEvents() && this.ssoOwnsAnalytics) {
                pendo.startSendingEvents();
            }
            if (pendo.track !== undefined) {
                pendo.track(event, metadata);
                if (this.ssoOwnsAnalytics) {
                    pendo.flushNow();
                }
            }
        }
    }
}
